import ReportingApi from '@api/ReportingApi';
import ReportingFileDownloaderApi from '@api/ReportingFileDownloaderApi';
// import Vue from 'vue';
import { formatDate } from '@/utils';

export default {
  GET_REPORTS(context, options = {}) {
    context.commit('SET_REPORTS_LOADING', true)
    context.commit('SET_REPORTING_USER_MESSAGE', '')
    return new ReportingApi({
      simulateExample: 'Get Report Types - External User'
    })
      .getReportTypes({
        params: {
          ...options.params,
          groupCk: context.rootGetters['groupSelector/selected'].groupCk,
          parentGroupCk: context.rootGetters['groupSelector/selected'].parentGroupCk
        }
      })
      .then(response => {
        if (response.status === 'NoReportFound') { context.commit('SET_REPORTING_USER_MESSAGE', response.userMessage) } else context.commit('SET_REPORTS', response.availableReports)
      })
      .catch(_ => {
        // todo
      })
      .finally(() => {
        context.commit('SET_REPORTS_LOADING', false)
      })
  },

  GET_ENROLLMENT_REPORTS (context, payload) {
    context.commit('SET_GENERATING_REPORT', true)
    context.commit('SET_REPORTING_USER_MESSAGE', '')
    return new ReportingFileDownloaderApi({
      fileName: `enrollment-report-${formatDate(new Date())}.csv`
    }) // no filename because we dont even know if we've got a file or a JSON response (refactor eventually)
      .getEnrollmentReports({ params: payload })
      .then(response => {
        if (response) { // a file was not downloaded...
          context.commit('SET_REPORTING_STATUS', response.status)
          context.commit('SET_REPORTING_USER_MESSAGE', response.userMessage || response.message)
        }
      })
      .catch(_ => {
        // todo
      })
      .finally(() => {
        context.commit('SET_GENERATING_REPORT', false)
      })
  },

  CLEAR_REPORTING(context) {
    context.commit('CLEAR_REPORTING')
  },

  DOWNLOAD_REPORT (context, options = {}) {
    // Now supports a downloadKey alternative since invoice files all have the same reportId
    // (invoice.invoiceNumber is considered the "reportId" on the API side)
    const reportIdKey = options.downloadKey || options.reportId
    context.commit('SET_REPORT_DOWNLOADING', { reportId: reportIdKey, reportIsDownloading: true })
    return new ReportingFileDownloaderApi({
      fileName: options.fileName
    }).getReportDownload({
      params: {
        reportId: options.reportId,
        type: options.type,
        invoicetype: options.invoiceType || '',
        dateOfService: options.dateOfService || '',
        groupCk: options.groupCk || '',
        subGroupCk: options.subGroupCk || ''
      }
    })
      .then((response) => {
      // If response is not there, it means a file was downloaded and no response should be returned.
      // Otherwise, there's a JSON payload with some userMessaging or something or other
        if (response) {
          context.commit('SET_ANNOUNCEMENT_WARNING', true, { root: true })
          context.commit('SET_ANNOUNCEMENT', response.userMessage, { root: true })
        }
      })
      .finally(() => {
        context.commit('SET_REPORT_DOWNLOADING', { reportId: reportIdKey, reportIsDownloading: false })
      })
  },

  DOWNLOAD_MULTIPLE_REPORTS (context, options = {}) {
  // downlowd multiple invoices
    context.commit('SET_MULTIPLE_REPORTS_DOWNLOADING', true)
    return new ReportingFileDownloaderApi({
      fileName: options.fileName
    }).getMultipleReportsDownload({
      body: {
        ...context.rootGetters['groupSelector/selected'],
        invoiceType: options.invoiceType,
        year: options.year,
        month: options.month,
        status: options.status
      }
    })
      .then((response) => {
        // If response is not there, it means a file was downloaded and no response should be returned.
        // Otherwise, there's a JSON payload with some userMessaging or something or other
        if (response) {
          context.commit('SET_ANNOUNCEMENT_WARNING', true, { root: true })
          context.commit('SET_ANNOUNCEMENT', response.userMessage, { root: true })
        }
      })
      .finally(() => {
        context.commit('SET_MULTIPLE_REPORTS_DOWNLOADING', false)
      })
  }

}
